module.exports = __webpack_public_path__ + "media/images/arrow-up-a5364f47.png";